(function () {
  function loadGlowImage(media) {
    var image = media.querySelector('.grid-product__glow-image-element');
    if (!image || image.getAttribute('src') || !image.dataset.glowSrc) return;
    image.setAttribute('src', image.dataset.glowSrc);
  }
  function updateToggle(button, media, isGlowActive) {
    var label = button.querySelector('[data-glow-card-label]');
    var productCard = button.closest('.grid-product');
    media.classList.toggle('is-glow-active', isGlowActive);
    button.setAttribute('aria-pressed', String(isGlowActive));
    button.setAttribute('aria-label', isGlowActive ? 'Show ' + button.dataset.glowProductTitle + ' in daylight' : 'Show ' + button.dataset.glowProductTitle + ' glowing');
    if (label) label.textContent = isGlowActive ? label.dataset.daylightLabel : label.dataset.glowLabel;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'glow_card_toggle', product_id: productCard.dataset.productId, product_handle: productCard.dataset.productHandle, collection_handle: productCard.dataset.collectionHandle || '', state: isGlowActive ? 'glow' : 'daylight' });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-glow-card-toggle]');
    if (!button) return;
    var media = button.closest('.grid-product__media--glow');
    if (!media) return;
    loadGlowImage(media);
    updateToggle(button, media, !media.classList.contains('is-glow-active'));
  });
})();
